import React, { useEffect, useRef, useState } from 'react';
import { NavHomeIcon } from '@repo/icons';
import ActivityAlertsModal from '@views/Activity/AlertsModal';
import NavigationItem from './NavigationItem';
import { useDispatch, useSelector } from 'react-redux';
import { selectActivityHasNewItems, selectAllActivity } from '@repo/redux/reducers/data/activity';
import { fetchActivity } from '@repo/redux/actions/activity';
import { useLocation } from 'react-router-dom';

// TODO: if there are unread alerts, set hasAlerts to true on NavigationItem

export default function ActivityNavItem() {
  const dispatch = useDispatch();
  const location = useLocation();
  const activity = useSelector(selectAllActivity);
  const hasNewActivityItems = useSelector(selectActivityHasNewItems);
  const timer = useRef(null);
  const [showModal, setShowModal] = useState<boolean>(false);

  const onMouseEnter = () => {
    timer.current = setTimeout(
      () => {
        window.location.pathname !== '/' && activity.items.size > 0 && setShowModal(true);
      },
      hasNewActivityItems ? 600 : 900,
    );
  };

  const onMouseLeave = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  };

  useEffect(() => {
    if (location.pathname !== '/') {
      dispatch(fetchActivity());
    }
  }, []);

  return (
    <>
      <NavigationItem
        IconComponent={NavHomeIcon}
        text="Home"
        to="/"
        id="home-navigation"
        scaleOnHover={true}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        active={showModal}
        hasAlert={hasNewActivityItems}
      />

      {showModal && <ActivityAlertsModal closeModal={() => setShowModal(false)} />}
    </>
  );
}
